export const TOTAL_STEPS = 4

export const GATE_INSUFFICIENT = 'insufficient'

export const ATTEMPT_MAX = 20

export const ANALYSIS_WAIT_MS = 10_000

export const REVISION_STEP = 3

export const CATEGORY_MAX = 2

export const TARGET_MAX = 3

export const RAW_TEXT_MAX = 2000
export const RAW_TEXT_MIN = 30

export const CONSENTS = [
  {
    key: 'privacy',
    label: '개인정보 수집·이용 동의 (필수)',
    desc: '이름·연락처를 수집합니다. 운영기관이 직접 연락드리는 데만 쓰고, 보관 기간은 1년이며 언제든 철회하실 수 있습니다.',
  },
  {
    key: 'disclose',
    label: '문제 내용 공개 동의 (필수)',
    desc: '등록하신 문제가 공개 화면과 지도에 실립니다. 연락처는 공개되지 않습니다.',
  },
] as const

export type ConsentKey = (typeof CONSENTS)[number]['key']
